import { Pipe, PipeTransform } from '@angular/core';
import { LookupData } from 'src/app/shared/models/lookup-data.model';

@Pipe({
    name: 'descriptionFromLookup'
})
export class DescriptionFromLookupPipe implements PipeTransform {

    transform(value: string, data: LookupData[]): string {
        if (!value || !data || !data.length)
            return value;
    
        const lookupDataMap = new Map<string, string>();
        const codesInValue = value.split(',');

        data.forEach((obj) => {
            lookupDataMap.set(obj.Code, obj.Description);
        });

        return codesInValue.map(x => lookupDataMap.get(x)).join(', ');
    }
}